import nativeHelper from "@/lib/nativeHelper"
import { InternalAxiosRequestConfig } from "axios"

/**
 * Adds 'Origin' header to auth requests on iOS.
 * iOS doesn't automatically send the 'Origin' header,
 * but it's required by BE auth endpoints to apply
 * mobile-specific session durations.
 */

const setOriginInterceptor = async (request: InternalAxiosRequestConfig) => {
  if (!request.url) {
    return request
  }

  const requiresOriginHeader =
    request.url.startsWith("/api/v1/auth") && nativeHelper.isIos()

  if (requiresOriginHeader) {
    request.headers = request.headers ?? {}
    request.headers.Origin = request.headers.Origin ?? window.location.origin
  }

  return request
}

export default setOriginInterceptor
